import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/caac_windDir.png'
import _imports_1 from '@/assets/images/vk_zl_line.png'
import _imports_2 from '@/assets/images/dangerIcon.png'


const _hoisted_1 = { class: "flying-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "alarm-container" }
const _hoisted_4 = { class: "caac-header flex-row" }
const _hoisted_5 = { class: "header-lf flex-row" }
const _hoisted_6 = { class: "header-rt flex-row" }
const _hoisted_7 = { class: "fps-container wind-dirct-container" }
const _hoisted_8 = { class: "fps-container" }
const _hoisted_9 = { class: "img-box" }
const _hoisted_10 = { class: "all-time" }
const _hoisted_11 = { class: "font-DIN" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "countdown-container" }
const _hoisted_14 = { class: "progress-box" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "uav-actions-container" }
const _hoisted_17 = { class: "btn-group flex-row" }
const _hoisted_18 = {
  key: 1,
  class: "grad-container"
}

import {ref} from 'vue'
import useFlying from './index'
import {NProgress, NCountdown,NMarquee} from 'naive-ui'
import  useMouseHide from '@/hooks/useMouseHide'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { isMouseHidden } = useMouseHide(3000)
const timeBoxRef = ref<HTMLDivElement | null>(null);
const timeBox = ref<HTMLDivElement | null>(null);
const progressRef = ref<HTMLDivElement | null>(null);
const flyCanvasRef = ref<HTMLDivElement | null>(null);

const {
    sceneImage,
    progressValue,
    receive,
    sum,
    speed,
  currentFile,
  maxFile,
    uavStatusList,
    connectIcon,
    currentTime,
    isShowAlarm,
    currentPage,
    handleRestart,
    currentStepIndex,
    altitude,
    horizonalSpeed,
    courseAngle,
    realTimeAngleOffset,
    angularSpeed,
    guidStatus,
    totalSeconds,
    fpsStatus,
    connectStatus,
    isReady,
    collisionAlarm,
    currentWindSpeed,
    resultType,
    subResultContent,
    resultConent,
    rightJoyStickYawTip,
    leftJoyStickYawTip,

    $config,
    containerWidth,
    $enum,
    lockStatus,
    lockIcon,
    handleBack,
    handleBackCallback,
    handleSwitch,
    currentSeconds,
    handleLock,
    onGround,
    engineInitialized,
    gradTotalTime,
    pageVisible,
    loading3D,
    loadingProgess,
    characterMode,
    handleOpenPDF
} = useFlying(timeBoxRef, timeBox, progressRef, flyCanvasRef,);


return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkm_remoteStatus = _resolveComponent("vkm-remoteStatus")!
  const _component_vkm_caacFlyInfo = _resolveComponent("vkm-caacFlyInfo")!
  const _component_vkm_caacRemote = _resolveComponent("vkm-caacRemote")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_caacPrompt = _resolveComponent("vkm-caacPrompt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentPage) == 1)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: _unref(sceneImage),
          receive: _unref(receive),
          sum: _unref(sum),
          speed: _unref(speed),
          currentFile: _unref(currentFile),
          maxFile: _unref(maxFile),
          progressValue: _unref(loadingProgess),
          title: _unref(loading3D).title,
          description: _unref(loading3D).description,
          pageType: _unref(loading3D).pageType
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _unref(isShowAlarm) || _unref(collisionAlarm)]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("i", {
            class: "iconfont-line vk_prevleft_line",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleBackCallback)('icon')))
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uavStatusList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(index <= _unref(currentStepIndex)?'uav-status-item active-status':'uav-status-item'),
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item), 1),
              (index != _unref(uavStatusList)?.length - 1)
                ? (_openBlock(), _createBlock(_component_vkm_svg, {
                    key: 0,
                    "icon-name": index < _unref(currentStepIndex)?'current_step':'uncurrent_step' ,
                    class: "icon"
                  }, null, 8, ["icon-name"]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "img-box" }, [
              _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_0,
                alt: ""
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_unref(currentWindSpeed)) + "m/s", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                class: "vk_zl_line",
                src: _imports_1,
                alt: ""
              }, null, -1)),
              _withDirectives(_createElementVNode("img", {
                class: "denger-icon",
                src: _imports_2,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleOpenPDF) && _unref(handleOpenPDF)(...args))),
                alt: ""
              }, null, 512), [
                [_vShow, _unref(fpsStatus) < 30]
              ])
            ]),
            _createElementVNode("p", null, [
              _cache[9] || (_cache[9] = _createTextVNode("FPS:")),
              _createElementVNode("span", {
                class: _normalizeClass({'danger':_unref(fpsStatus) < 30})
              }, _toDisplayString(_unref(fpsStatus)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "all_time",
              class: "icon"
            }),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(gradTotalTime)), 1)
          ]),
          _createElementVNode("img", {
            src: _unref(connectIcon),
            alt: ""
          }, null, 8, _hoisted_12)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          ref_key: "timeBoxRef",
          ref: timeBoxRef,
          class: "progress-content"
        }, [
          (_unref(totalSeconds) != -1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-time time-container':'time-container'),
                ref_key: "timeBox",
                ref: timeBox
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(currentTime)), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dv3" }, null, -1)),
            (_unref(totalSeconds) != -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_unref(currentSeconds) >= 1 && _unref(totalSeconds) - _unref(currentSeconds) >= 1 && _unref(pageVisible)?'animation-dv4 dv4':'dv4'),
                  ref_key: "progressRef",
                  ref: progressRef
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(lockStatus) == _unref($enum).SWITCH_STATUS.ON && !_unref(onGround)?'none-click-btn lock-container':'lock-container' ),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handleLock) && _unref(handleLock)(...args)))
      }, [
        _createElementVNode("img", {
          src: _unref(lockIcon),
          alt: ""
        }, null, 8, _hoisted_15)
      ], 2),
      _createVNode(_component_vkm_remoteStatus, {
        isRemoteConnected: !!_unref(connectStatus),
        isReady: _unref(isReady)
      }, null, 8, ["isRemoteConnected", "isReady"]),
      _createVNode(_component_vkm_caacFlyInfo, {
        altitude: _unref(altitude),
        horizonalSpeed: _unref(horizonalSpeed),
        courseAngle: _unref(courseAngle),
        realTimeAngleOffset: _unref(realTimeAngleOffset),
        angularSpeed: _unref(angularSpeed),
        isMouseHidden: _unref(isMouseHidden),
        isShowDeviation: false
      }, null, 8, ["altitude", "horizonalSpeed", "courseAngle", "realTimeAngleOffset", "angularSpeed", "isMouseHidden"]),
      _createVNode(_component_vkm_caacRemote, {
        leftJoyYaw: _unref(leftJoyStickYawTip),
        rightJoyYaw: _unref(rightJoyStickYawTip),
        isReady: _unref(isReady)
      }, null, 8, ["leftJoyYaw", "rightJoyYaw", "isReady"]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_vkn_button, {
            label: _unref(guidStatus) == 1?'关闭引导':'开启引导',
            type: "tertiary",
            size: "medium",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(handleSwitch)('guid')))
          }, {
            icon: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "iconfont-line vk_jz_line1" }, null, -1)
            ])),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_vkn_button, {
            class: "insert-btn",
            label: "视角",
            type: "tertiary",
            size: "medium",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleSwitch)('view')))
          }, {
            icon: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "iconfont-line vk_qh_line" }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_vkn_button, {
            label: "重置",
            type: "tertiary",
            size: "medium",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(handleSwitch)('reset')))
          }, {
            icon: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "canvas-container info-btn",
          ref_key: "flyCanvasRef",
          ref: flyCanvasRef
        }, null, 512)
      ])
    ], 512), [
      [_vShow, _unref(currentPage) == 2]
    ]),
    (_unref(currentPage) == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_vkm_caacPrompt, {
            type: _unref(resultType),
            content: _unref(resultConent),
            subContent: _unref(subResultContent),
            onOnBack: _unref(handleBackCallback),
            onOnRestart: _cache[6] || (_cache[6] = ($event: any) => (_unref(handleRestart)(false)))
          }, null, 8, ["type", "content", "subContent", "onOnBack"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})